import styled from "@emotion/styled";
import { Item } from "@radix-ui/react-dropdown-menu";

import Button, {
  AnchorButtonProps,
  ButtonButtonProps,
  RouterAnchorButtonProps,
} from "../button/Button";
import TooltipComponent, { TooltipComponentProps } from "../tooltip/Tooltip";

type CommonDropdownMenuItemProps = {
  onSelect?: (event: Event) => void;
  textValue?: string;
  tooltip?: Omit<TooltipComponentProps, "children">;
};

type DropdownMenuItemProps = CommonDropdownMenuItemProps &
  (RouterAnchorButtonProps | AnchorButtonProps | ButtonButtonProps);

const DropdownButton = styled(Button)(({ theme }) => ({
  "&:hover": {
    outline: "none",
  },
  "&[data-active=true]": {
    backgroundColor: theme.colors.sysPrimarySubtle,
  },
}));

const DropdownMenuItem = ({ onSelect, textValue, tooltip, ...props }: DropdownMenuItemProps) => {
  const itemContent = (
    <Item asChild disabled={props.disabled} onSelect={onSelect} textValue={textValue}>
      <DropdownButton
        buttonStyle="inverse"
        buttonType="primary"
        width="100%"
        justifyContent="left"
        {...(props as ButtonButtonProps)}
      />
    </Item>
  );

  if (tooltip) {
    return <TooltipComponent {...tooltip}>{itemContent}</TooltipComponent>;
  }

  return itemContent;
};

export default DropdownMenuItem;
